var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 52,
    viewBox: "0 0 247 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.82 0C29.138 0 33 3.926 33 9.335V20h-3.721V9.335c0-3.061-2.45-5.551-5.46-5.551s-5.458 2.49-5.458 5.55V20h-3.722V9.335c0-3.061-2.45-5.551-5.46-5.551s-5.458 2.49-5.458 5.55V20H0V9.335C0 3.926 3.86 0 9.18 0c2.803 0 5.843 1.746 7.32 4.18C17.966 1.748 21.006 0 23.82 0z",
    id: "5czg5f8vqa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 3.774A6.234 6.234 0 0 0 3.774 10 6.235 6.235 0 0 0 10 16.227 6.235 6.235 0 0 0 16.227 10 6.234 6.234 0 0 0 10 3.774z",
    id: "yc92ozghwc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 3.774A6.233 6.233 0 0 0 3.774 10 6.234 6.234 0 0 0 10 16.227 6.234 6.234 0 0 0 16.227 10 6.234 6.234 0 0 0 10 3.774z",
    id: "zir71ojgne"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85 0v10.926C5.195 9.454 7.232 8.617 9.5 8.617c5.505 0 9.5 4.001 9.5 9.514V29h-3.851V18.13c0-3.119-2.534-5.657-5.65-5.657-3.114 0-5.648 2.538-5.648 5.658V29H0V0h3.85z",
    id: "ri7rax0d6g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.514 0 10 4.183 10 10v9.751h-3.774v-2.465C14.323 19.087 12.23 20 10 20 4.486 20 0 15.515 0 10 0 4.487 4.486 0 10 0zm0 3.774A6.233 6.233 0 0 0 3.773 10 6.234 6.234 0 0 0 10 16.227 6.234 6.234 0 0 0 16.226 10 6.233 6.233 0 0 0 10 3.774z",
    id: "syh9lxycui"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0C3.879 0 5 1.122 5 2.5S3.879 5 2.5 5A2.503 2.503 0 0 1 0 2.5C0 1.122 1.122 0 2.5 0z",
    id: "p1mt44711k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.773 0v11.73C5.677 9.93 7.77 9.016 10 9.016c5.514 0 10 4.482 10 9.992C20 24.519 15.514 29 10 29S0 24.518 0 19.009V0h3.773zM10 12.788c-3.434 0-6.227 2.79-6.227 6.221 0 3.43 2.793 6.221 6.227 6.221s6.226-2.791 6.226-6.221-2.792-6.221-6.226-6.221z",
    id: "a7tjw1a4sm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.762 0c.073 0 .146 0 .22.003 2.947.072 5.454 1.138 7.248 3.082 1.882 2.04 2.912 4.987 2.754 7.882l-.011.236c-.013.27-.026.551-.058.74l-.019.111h-15.8c.884 2.466 3.276 4.173 5.882 4.173 1.782 0 3.482-.77 4.662-2.11l.088-.1 2.823 2.497-.087.099A9.98 9.98 0 0 1 9.978 20C4.477 20 0 15.514 0 10.001 0 4.581 4.47 0 9.762 0zm.216 3.776c-2.823 0-5.33 1.964-6.023 4.693H16c-.693-2.73-3.2-4.693-6.023-4.693z",
    id: "9ro9rwrzlo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0z",
    id: "56ku2cjq8q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.039 0C15.867 0 18 1.923 18 4.474V10h-1.842V4.474c0-1.551-1.4-2.812-3.12-2.812-1.718 0-3.117 1.26-3.117 2.812V10H8.08V4.474c0-1.551-1.4-2.812-3.118-2.812-1.72 0-3.118 1.26-3.118 2.812V10H0V4.474C0 1.923 2.133 0 4.961 0 6.573 0 8.125.746 9 1.922 9.873.746 11.426 0 13.039 0z",
    id: "89ibqpjhws"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.647 0v6.023c0 1.714 1.28 3.11 2.853 3.11 1.572 0 2.852-1.396 2.852-3.11V0H9v11.092C9 13.798 6.98 16 4.5 16 2.518 16 .79 14.614.203 12.551l-.11-.383 1.573-.534.11.383c.372 1.307 1.467 2.186 2.724 2.186 1.572 0 2.852-1.395 2.852-3.111V9.705c-.792.763-1.853 1.226-2.852 1.226-2.48 0-4.5-2.202-4.5-4.908V0h1.647z",
    id: "n5lp43f9gu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76 0v20.964c0 2.654 1.136 3.944 3.474 3.944.117 0 .234-.004.353-.009L8 24.876v4.008l-.349.044A8.402 8.402 0 0 1 6.565 29C2.515 29 0 25.966 0 21.081V0h3.76z",
    id: "lx3il0j21w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.759 0v20.964c0 2.654 1.136 3.944 3.474 3.944a8.2 8.2 0 0 0 .354-.009L8 24.876v4.008l-.35.044A8.4 8.4 0 0 1 6.564 29C2.514 29 0 25.966 0 21.081V0h3.759z",
    id: "4kt48pkeay"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0c3.308 0 6 2.692 6 6 0 3.309-2.692 6-6 6-3.309 0-6-2.691-6-6 0-3.308 2.691-6 6-6zm0 3.529A2.475 2.475 0 0 0 3.529 6a2.475 2.475 0 0 0 2.473 2.472A2.475 2.475 0 0 0 8.473 6 2.475 2.475 0 0 0 6.001 3.53z",
    id: "lt9nvjq33A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 3.774A6.234 6.234 0 0 0 3.773 10 6.234 6.234 0 0 0 10 16.227 6.234 6.234 0 0 0 16.226 10 6.233 6.233 0 0 0 10 3.774z",
    id: "86zdbopa0C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 18)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ysbyp01hqb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5czg5f8vqa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#ysbyp01hqb)",
    d: "M0 20h33V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "appbnlqzad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yc92ozghwc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#appbnlqzad)",
    d: "M0 20h20V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d6ikecakbf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zir71ojgne"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#d6ikecakbf)",
    d: "M0 20h20V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vq4uzob5bh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ri7rax0d6g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#vq4uzob5bh)",
    d: "M0 29h19V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(113 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n827lo71kj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#syh9lxycui"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#n827lo71kj)",
    d: "M0 20h20V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54 16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u99dcp7dql",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p1mt44711k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#u99dcp7dql)",
    d: "M0 5h5V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kad5lwa02n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7tjw1a4sm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#kad5lwa02n)",
    d: "M0 29h20V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tiyoyuhfqp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9ro9rwrzlo"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#tiyoyuhfqp)",
    d: "M0 20h20V0H0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "arpdv4nv2r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#56ku2cjq8q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#arpdv4nv2r)",
    d: "M0 36h36V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k2yh5tyzit",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#89ibqpjhws"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#k2yh5tyzit)",
    d: "M0 10h18V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kcwd8tu9rv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n5lp43f9gu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#kcwd8tu9rv)",
    d: "M0 16h9V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2yg3tjmokx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lx3il0j21w"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#2yg3tjmokx)",
    d: "M0 29h8V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lkcvyjkadz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4kt48pkeay"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#lkcvyjkadz)",
    d: "M0 29h8V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 40)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2mzto49pkB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt9nvjq33A"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#2mzto49pkB)",
    d: "M0 12h12V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sfuyi85boD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#86zdbopa0C"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#sfuyi85boD)",
    d: "M0 20h20V0H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e11d0803b5f5f2e0128501583907d5b6.svg";
export { ForwardRef as ReactComponent };